import { render } from "./SimpleLorePage.vue?vue&type=template&id=001f8adc"
import script from "./SimpleLorePage.vue?vue&type=script&lang=js"
export * from "./SimpleLorePage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__